import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { object, ObjectSchema } from 'yup'
import { booleanSchema } from 'src/Configuration/validation'

/**
 * This hook provides the validation schema for storages using the custom defined yup-validation-rules
 */
const useOverviewValidation = (): {
  validationSchema: ObjectSchema<{ agreementAcceptance: boolean }>
} => {
  const { t } = useCustomTranslation()
  const booleanSchemaWithTranslation = booleanSchema(t)

  const validationSchema = object().shape({
    agreementAcceptance: booleanSchemaWithTranslation({ hasToBeTrue: true }).required(),
  })

  return { validationSchema }
}

export default useOverviewValidation
